(() => {
    const SELECTOR = "[data-site-select]";
    const LIST_STYLE_PROPS = [
        "position",
        "top",
        "right",
        "bottom",
        "left",
        "width",
        "maxWidth",
        "maxHeight",
        "zIndex",
        "overflow",
    ];

    function closeAll(except) {
        document.querySelectorAll(SELECTOR).forEach((root) => {
            if (root !== except) {
                setOpen(root, false);
            }
        });
    }

    function clearListPosition(list) {
        LIST_STYLE_PROPS.forEach((prop) => {
            list.style[prop] = "";
        });
    }

    function usesLocalList(root) {
        return Boolean(
            root.closest(".form-orcamento-site")
            || root.closest(".catalog-toolbar")
            || root.closest(".site-filter-dialog")
        );
    }

    function placeList(root) {
        const trigger = root.querySelector(".site-select-trigger");
        const list = root.querySelector(".site-select-list");
        if (!trigger || !list || list.hidden) {
            return;
        }
        if (usesLocalList(root)) {
            clearListPosition(list);
            requestAnimationFrame(() => {
                if (list.hidden) {
                    return;
                }
                const triggerRect = trigger.getBoundingClientRect();
                const listRect = list.getBoundingClientRect();
                if (listRect.right > window.innerWidth - 16) {
                    list.style.left = "auto";
                    list.style.right = "0";
                }
                if (listRect.bottom > window.innerHeight - 12 && triggerRect.top > listRect.height + 12) {
                    list.style.top = "auto";
                    list.style.bottom = "calc(100% + 6px)";
                }
            });
            return;
        }

        const rect = trigger.getBoundingClientRect();
        const gap = 6;
        const viewportH = window.innerHeight;
        const spaceBelow = viewportH - rect.bottom - gap;
        const spaceAbove = rect.top - gap;
        const preferred = Math.min(288, viewportH * 0.45);
        const openUp = spaceBelow < 140 && spaceAbove > spaceBelow;
        const available = openUp ? spaceAbove : spaceBelow;
        const maxHeight = Math.max(120, Math.min(preferred, available));

        list.style.position = "fixed";
        list.style.left = `${Math.round(rect.left)}px`;
        list.style.width = `${Math.round(rect.width)}px`;
        list.style.maxWidth = "none";
        list.style.zIndex = "320";
        list.style.overflow = "auto";
        list.style.maxHeight = `${Math.round(maxHeight)}px`;

        if (openUp) {
            list.style.top = "auto";
            list.style.bottom = `${Math.round(viewportH - rect.top + gap)}px`;
        } else {
            list.style.bottom = "auto";
            list.style.top = `${Math.round(rect.bottom + gap)}px`;
        }
    }

    function setOpen(root, open) {
        const trigger = root.querySelector(".site-select-trigger");
        const list = root.querySelector(".site-select-list");
        if (!trigger || !list) {
            return;
        }
        trigger.setAttribute("aria-expanded", open ? "true" : "false");
        list.hidden = !open;
        root.classList.toggle("is-open", open);
        if (!open) {
            clearListPosition(list);
            return;
        }

        placeList(root);
        const selected = list.querySelector(".is-selected") || list.querySelector("[role='option']");
        selected?.scrollIntoView({ block: "nearest" });
    }

    function selectOption(root, option) {
        const native = root.querySelector(".site-select-native");
        const valueNode = root.querySelector(".site-select-value");
        const list = root.querySelector(".site-select-list");
        if (!native || !option) {
            return;
        }

        const value = option.getAttribute("data-value") ?? "";
        native.value = value;
        if (valueNode) {
            valueNode.textContent = option.textContent?.trim() || "";
        }
        list?.querySelectorAll("[role='option']").forEach((item) => {
            item.classList.toggle("is-selected", item === option);
        });
        native.dispatchEvent(new Event("change", { bubbles: true }));
        setOpen(root, false);
    }

    function onDocumentClick(event) {
        const root = event.target.closest(SELECTOR);
        if (!root) {
            closeAll(null);
            return;
        }

        const trigger = event.target.closest(".site-select-trigger");
        const option = event.target.closest("[role='option']");

        if (trigger) {
            const willOpen = trigger.getAttribute("aria-expanded") !== "true";
            closeAll(root);
            setOpen(root, willOpen);
            return;
        }

        if (option) {
            selectOption(root, option);
        }
    }

    function onKeyDown(event) {
        const root = event.target.closest(SELECTOR);
        if (!root) {
            if (event.key === "Escape") {
                closeAll(null);
            }
            return;
        }

        const list = root.querySelector(".site-select-list");
        const options = [...(list?.querySelectorAll("[role='option']") || [])];
        const current = list?.querySelector(".is-selected");
        const index = options.indexOf(current);
        const isOpen = root.classList.contains("is-open");

        if (event.key === "Escape") {
            setOpen(root, false);
            root.querySelector(".site-select-trigger")?.focus();
            return;
        }

        if (event.key === "Enter" || event.key === " ") {
            if (!isOpen) {
                event.preventDefault();
                closeAll(root);
                setOpen(root, true);
            } else if (current) {
                event.preventDefault();
                selectOption(root, current);
            }
            return;
        }

        if (event.key === "ArrowDown" || event.key === "ArrowUp") {
            event.preventDefault();
            if (!isOpen) {
                closeAll(root);
                setOpen(root, true);
                return;
            }
            const delta = event.key === "ArrowDown" ? 1 : -1;
            const next = options[Math.max(0, Math.min(options.length - 1, (index < 0 ? 0 : index) + delta))];
            options.forEach((item) => item.classList.toggle("is-selected", item === next));
            next?.scrollIntoView({ block: "nearest" });
        }
    }

    function repositionOpen() {
        document.querySelectorAll(`${SELECTOR}.is-open`).forEach(placeList);
    }

    function boot() {
        document.querySelectorAll(SELECTOR).forEach((root) => {
            root.classList.add("is-enhanced");
        });
    }

    document.addEventListener("click", onDocumentClick);
    document.addEventListener("keydown", onKeyDown);
    window.addEventListener("resize", repositionOpen);
    window.addEventListener("scroll", repositionOpen, true);
    window.siteReady(boot);
})();
